const _ = require("lodash");
const StringUtil = require("../../../shared/StringUtil");
const ErrorUtil = require("../../../shared/ErrorUtil");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const BeastBuilderShared = require("../../../shared/BeastBuilderShared");
const moment = require("moment");

global.BASE_URL = global.BASE_URL ?? "/";

// For Beasts

const getBeastImgName = function(styleType, gradeNumber, forGrade = true) {
	const staticBeasts = [
		"review",
		"challenge",
		"clod",
		"rg",
		"announcer",
		"team",
		"lab",
	];
	let imgName = styleType;
	if (styleType === "grok") {
		if (gradeNumber === 2) {
			imgName += "-grade" + gradeNumber;
		}
	} else if (!_.includes(staticBeasts, styleType)) {
		if (!gradeNumber) {
			gradeNumber = 3;
			ErrorUtil.log(
				"E_MISSING_PARAMETER",
				"gradeNumber missing for styleType " + styleType
			);
		}
		if (forGrade) {
			imgName += "-grade" + gradeNumber;
		}
	}
	return imgName;
};

const getBeastAvatar = function(styleType, gradeNumber, props = {}) {
	if (_.isNil(props.forGrade)) {
		props.forGrade = true;
	}
	let imgName =
		styleType === "lab"
			? "pl-" + props.character
			: getBeastImgName(styleType, gradeNumber, props.forGrade);
	if (props.isCircle) {
		imgName += "-circle";
	}
	if (props.isBlue) {
		imgName += "-blue";
	}
	if (props.isGray) {
		imgName += "-gray";
	}
	return (
		global.BASE_URL + `assets/images/characters/avatars/avatar-${imgName}.svg`
	);
};

const getBeastPopin = function(styleType, gradeNumber, extraType = null) {
	let pre = "";
	if (extraType === "happy") {
		//Beasts that look different when happy:
		const happyBeasts = ["fiona", "grok", "kraken", "q"];
		if (_.includes(happyBeasts, styleType)) {
			pre = "happy-";
		}
	}
	const imgName = getBeastImgName(styleType, gradeNumber);
	return (
		global.BASE_URL +
		`assets/images/characters/popins/popin-${pre}${imgName}.svg`
	);
};

const getBeastModalImage = function(character, pose) {
	return (
		global.BASE_URL + `assets/images/characters/modals/${character}-${pose}.svg`
	);
};

const getHeadmasterWithMood = function(mood) {
	return (
		global.BASE_URL +
		`assets/images/characters/tutorial/headmaster-tutorial-${mood}.svg`
	);
};

const getBeastInstruction = function(styleType, gradeNumber) {
	const imgName = getBeastImgName(styleType, gradeNumber);
	return (
		global.BASE_URL +
		`assets/images/characters/instructions/instructions-${imgName}.svg`
	);
};

const getBeastPartBase = function(partID) {
	return global.BASE_URL + `public/bpbase/${partID}.svg`;
};

const getTutorialBookPage = function(name) {
	return global.BASE_URL + `assets/images/tutorial/tutorial-${name}.jpg`;
};

const getBlockImage = function(type, color) {
	const baseUrl = global.BASE_URL + "assets/images/problem-art/blocks/";
	if (color) {
		return baseUrl + `beast-blocks-${type}-${color}.svg`;
	} else {
		return baseUrl + `beast-blocks-${type}-skyblue.svg`;
	}
};

const getBTenBlockImage = function(type, color) {
	const baseURL = global.BASE_URL + "assets/images/problem-art/btenblocks/";
	if (color) {
		return baseURL + `bten-blocks-${type}-${color}.svg`;
	} else {
		return baseURL + `bten-blocks-${type}-skyblue.svg`;
	}
};

const getSilhouette = function(styleType, color) {
	return (
		global.BASE_URL +
		`assets/images/office/characters/silhouette-${styleType}-${color}.svg`
	);
};

const getCoinImage = (type, position) => {
	switch (type) {
		case "H":
		case "h":
			return (
				global.BASE_URL +
				"assets/images/problem-art/coins/beast-coins-heads-perspective" +
				position +
				".svg"
			);
		case "T":
		case "t":
			return (
				global.BASE_URL +
				"assets/images/problem-art/coins/beast-coins-tails-perspective" +
				position +
				".svg"
			);
		case "s":
			return (
				global.BASE_URL +
				"assets/images/problem-art/coins/beast-coins-tails-10.svg"
			);
		case "f":
			return (
				global.BASE_URL +
				"assets/images/problem-art/coins/beast-coins-tails-front-view.svg"
			);
		case "b":
			return (
				global.BASE_URL +
				"assets/images/problem-art/coins/beast-coins-tails-back-view.svg"
			);
	}
};

const getSummaryBeast = function(styleType, gradeNumber, numStars) {
	let imgName = getBeastImgName(styleType, gradeNumber);
	if (styleType !== "rote") {
		imgName += "-stars-" + numStars;
	} else {
		imgName += "-stars";
	}
	return (
		global.BASE_URL + "assets/images/summary/characters/" + imgName + ".svg"
	);
};

const getSummaryLabBeast = function(celestialHash) {
	return (
		global.BASE_URL +
		"assets/images/summary/characters/lab-" +
		celestialHash +
		".svg"
	);
};

const getTestOverviewBeast = function(styleType, gradeNumber) {
	const imgName = getBeastImgName(styleType, gradeNumber);
	return (
		global.BASE_URL +
		"assets/images/characters/testoverview/" +
		imgName +
		".svg"
	);
};

const getLoginCharacters = function(type) {
	const char = type === "left" ? "left" : "right";
	return global.BASE_URL + "assets/images/characters/login-" + char + ".svg";
};

const getTrainerIconButton = function(name) {
	return global.BASE_URL + "assets/images/icons/button-" + name + ".svg";
};

const getVolumeIcon = function(name) {
	return global.BASE_URL + "assets/images/icons/volume-" + name + ".svg";
};

const getGeneralIcon = function(type) {
	return global.BASE_URL + "assets/images/icons/" + type + ".svg";
};

/**
 * @param {string} symbolName
 * @param {string} color
 * @returns {string} image URL
 */
const getPirateImage = function(symbolName, color) {
	const file = color
		? "assets/images/problem-art/pirate/color/" +
		  symbolName +
		  "-" +
		  color +
		  ".svg"
		: "assets/images/problem-art/pirate/" + symbolName + ".svg";
	return global.BASE_URL + file;
};

// For profile

const getProfileIcon = function(type, inColor) {
	const suffix = inColor ? "-profile" : "-gray";
	return global.BASE_URL + "assets/images/icons/icon-" + type + suffix + ".svg";
};

const getIntervenedImage = function() {
	return global.BASE_URL + "assets/images/icons/intervention.svg";
};

const getImageForGrade = function(grade, color = "colorful") {
	return (
		global.BASE_URL +
		"assets/images/icons/level/grade-" +
		grade +
		"-" +
		color +
		".svg"
	);
};

const getImageForChapterInGrade = function(chapter, color = "yellow") {
	if (_.isNumber(color)) {
		return (
			global.BASE_URL +
			"assets/images/icons/level/grade-" +
			color +
			"-chapter-" +
			chapter +
			".svg"
		);
	} else {
		return (
			global.BASE_URL +
			"assets/images/icons/level/chapter-" +
			chapter +
			"-" +
			color +
			".svg"
		);
	}
};

const getTrayImageByGrade = function(name, color) {
	if (_.isInteger(color)) {
		return (
			global.BASE_URL + `assets/images/elements/trays/${name}-grade${color}.svg`
		);
	} else {
		return (
			global.BASE_URL + `assets/images/elements/trays/${name}-${color}.svg`
		);
	}
};

const getTrayImageForTeacher = function(name) {
	return global.BASE_URL + `assets/images/elements/trays/${name}-teacher.svg`;
};

const getLockImage = function(color = "gray") {
	return (
		global.BASE_URL + "assets/images/icons/button-lock-locked-" + color + ".svg"
	);
};

// For Trainer

const getTrainerIcon = (type, isComplete) => {
	const suffix = isComplete ? "-gold" : "-blue";
	return global.BASE_URL + "assets/images/icons/icon-" + type + suffix + ".svg";
};

const getStarEarned = function(number, isEarned) {
	const earned = isEarned ? "-earned" : "-gray";
	return (
		global.BASE_URL +
		"assets/images/icons/stars/star" +
		number +
		earned +
		".svg"
	);
};

//number can be one of 0, 1, 2, 3, unearned
const getStarImage = function(number, isPath) {
	return (
		global.BASE_URL +
		"assets/images/icons/stars/star-" +
		number +
		(isPath ? "-path" : "") +
		".svg"
	);
};

/**
 * Remove spaces and pascal case names.
 *
 * ex. team and Banda => TeamAndBanda
 *
 * @param {string} name Name of the lab type, in plain English. ex. Spiral Galaxies.
 */
const getLabKey = name => {
	return StringUtil.pascalCase(name);
};

/**
 * Gets the image of the lab type.
 *
 * @param {string} name        Name of the lab type, in plain English. ex. Spiral Galaxies.
 * @param {boolean} locked     Whether the lab type is locked for the specific user.
 * @param {boolean} borderless Whether to fetch the URL of the borderless version of the icon.
 */
const getLabTypeImage = function(name, locked = false, borderless = false) {
	const labTypeIconBaseURL = global.BASE_URL + "assets/images/icons/PL_ICON_";
	const labKey = getLabKey(name);

	const lockedSpecifier = (() => {
		// no locked / unlocked icons for borderless
		if (borderless) {
			return "";
		}
		return (locked ? "LOCKED" : "UNLOCKED") + "_";
	})();

	return labTypeIconBaseURL + lockedSpecifier + labKey + ".svg";
};

/**
 * @param {string} name Name of the lab type, in plain English. ex. Spiral Galaxies.
 */
const getLabSampleImage = function(name) {
	return (
		global.BASE_URL +
		"assets/images/icons/PL_PuzzleSample_" +
		getLabKey(name) +
		".svg"
	);
};

const getCelestialImage = function(name, earned, color = "gray") {
	return (
		global.BASE_URL +
		"assets/images/icons/celestials/" +
		name +
		(earned ? "" : "-" + color) +
		".svg"
	);
};

const getLabTypeCelestialImage = function(celestialHash, complete) {
	return (
		global.BASE_URL +
		"assets/images/icons/lab-" +
		celestialHash +
		"-" +
		(complete ? "complete" : "incomplete") +
		".svg"
	);
};

const getButton = function(type, color = "", includeBaseUrl = true) {
	const start = includeBaseUrl ? global.BASE_URL : "";
	return (
		start +
		"assets/images/icons/button-" +
		type +
		(color ? "-" + color : "") +
		".svg"
	);
};

const getButtonForSpace = function(space, color) {
	if (space === "class") {
		return getButton("bell", color);
	} else if (space === "lab") {
		return getButton("puzzle", color);
	} else if (space === "theater") {
		return getButton("projector", color);
	} else if (space === "library") {
		return getButton("book", color);
	}
};

const getButtonCircle = function(name) {
	return global.BASE_URL + "assets/images/icons/button-circle-" + name + ".svg";
};

const getButtonChapterCircle = function(chapterNumber) {
	return getButtonCircle("chapter-" + chapterNumber);
};

const getProfileDefaultAvatar = function(num) {
	return BeastBuilderShared.getAvatarURL({num});
};

const getDefaultAvatarIcon = function(name) {
	return (
		global.BASE_URL + "assets/images/icons/default-avatars/" + name + ".svg"
	);
};

const getBlockBeast = function(grade, beast, isUnlocked) {
	if (beast === "headmaster") {
		return (
			global.BASE_URL + "assets/images/blocks/block-button-misc-headmaster.svg"
		);
	} else if (!_.isNumber(grade)) {
		return (
			global.BASE_URL +
			"assets/images/blocks/block-button-" +
			grade +
			beast +
			(isUnlocked ? "" : "-locked") +
			".svg"
		);
	} else {
		const suffix = grade === 1 || grade === 2 || grade === 3 ? "-v2" : "";
		return (
			global.BASE_URL +
			"assets/images/blocks/block-button-grade" +
			grade +
			"-" +
			beast +
			(isUnlocked ? "" : "-locked") +
			suffix +
			".svg"
		);
	}
};

const getBlockLock = function(num, isOpaque) {
	return (
		global.BASE_URL +
		`assets/images/blocks/block-button-lock${num}${
			isOpaque ? "-opaque" : ""
		}.svg`
	);
};

const getUnderConstruction = function() {
	return (
		global.BASE_URL + "assets/images/blocks/block-button-under-construction.svg"
	);
};

const getHWIcon = function(isAcademy, isComplete) {
	const complete = isComplete ? "-complete" : "";
	return global.BASE_URL + `assets/images/icons/homework-hw${complete}.svg`;
};

const getAuxButton = function(blockType, gradeNumber, specialType) {
	// specialType as in -locked, -construction
	return (
		global.BASE_URL +
		"assets/images/blocks/aux-block-" +
		blockType +
		`-grade${gradeNumber}` +
		specialType +
		".svg"
	);
};

const getTooltip = function(size) {
	return `${global.BASE_URL}assets/images/elements/tooltips/tooltip-${size}.svg`;
};

const getInstructionsModal = function(styleType) {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/instructions/instructions-" +
		styleType +
		".svg"
	);
};

const getTopBar = function(type) {
	return (
		global.BASE_URL +
		"assets/images/elements/ba-top-bar" +
		(type ? "-" + type : "") +
		".svg"
	);
};

const getModal = function(type) {
	return global.BASE_URL + "assets/images/elements/modals/" + type + ".svg";
};

const getLevelModal = function(type) {
	return (
		global.BASE_URL + "assets/images/elements/modals/levelup/" + type + ".svg"
	);
};

const getStartTestIllustration = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/start-test/start-test-illustration.svg"
	);
};

const getHomeworkAllCompleteIllustration = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/homework-all-complete/homework-all-complete-illustration.svg"
	);
};

const getChapterCompleteIllustration = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/chapter-complete/chapter-complete-illustration.svg"
	);
};

const getAcademyGraduateCurtains = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/academy-graduate/academy-graduate-curtains.svg"
	);
};

const getAcademyGraduateSpotlight = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/academy-graduate/academy-graduate-spotlight.svg"
	);
};

const getAcademyGraduateCap = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/academy-graduate/academy-graduate-cap.svg"
	);
};

const getAcademyGraduateCompletionCertificateSvg = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/academy-graduate/beast-academy-completion-certificate.svg"
	);
};

/**
 * Chapter-path overlay for the culminating final test room (golden vs gray cap).
 * @param {boolean} hasPassedFinalTest any stars on the final test.
 */
const getChapterPathFinalAcademyTestImage = function(hasPassedFinalTest) {
	const file = hasPassedFinalTest
		? "chapter-path-final-academy-cap-complete.svg"
		: "chapter-path-final-academy-cap-incomplete.svg";
	return (
		global.BASE_URL + "assets/images/elements/modals/academy-graduate/" + file
	);
};

const getContinuousPlayStreakIllustration = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/continuous-play/continuous-play-streak-illustration.svg"
	);
};

const getConfirmModal = function(styleType) {
	if (styleType === "chapterPage") {
		return global.BASE_URL + "assets/images/elements/modals/chapter-page.svg";
	} else if (styleType === "generic") {
		return (
			global.BASE_URL +
			"assets/images/elements/modals/message-modal-generic.svg"
		);
	} else if (styleType === "placementTest") {
		return (
			global.BASE_URL +
			"assets/images/elements/modals/placement-test-invite/placement-test-invite-modal-bg.svg"
		);
	}
	return (
		global.BASE_URL +
		"assets/images/elements/modals/confirm/confirm-" +
		styleType +
		".svg"
	);
};

const getChapterCover = function(bookHash, chapterNumber) {
	return (
		global.BASE_URL +
		"assets/books/" +
		bookHash +
		"/chapters/cover-" +
		chapterNumber +
		".png"
	);
};

const getBookCover = function(bookHash, type = "guide", size = "small") {
	return BookstoreUtil.getBookCoverSrc(bookHash, type === "practice", size);
};

const getBookIcon = function(bookHash) {
	return global.BASE_URL + "assets/images/icons/book/book-" + bookHash + ".svg";
};

const getSparkle = function(type = "small", isLab = false) {
	const folder = isLab ? "lab" : "trophy";
	return (
		global.BASE_URL +
		"assets/images/animations/" +
		folder +
		"/sparkle-" +
		type +
		".svg"
	);
};

const getLabElement = function(type) {
	return global.BASE_URL + "assets/images/elements/lab/" + type + ".svg";
};

const getSummaryRect = function(typeOrStars) {
	if (typeOrStars === "results") {
		return (
			global.BASE_URL + "assets/images/summary/rectangles/results-rectangle.svg"
		);
	} else if (typeOrStars > 0) {
		return (
			global.BASE_URL +
			"assets/images/summary/rectangles/sunburst-yellow-background.svg"
		);
	} else {
		return (
			global.BASE_URL + "assets/images/summary/rectangles/blue-background.svg"
		);
	}
};

const getSummaryLabRectBackground = function() {
	return (
		global.BASE_URL +
		"assets/images/summary/rectangles/lab-yellow-swirl-background.svg"
	);
};

const getSummaryLabRectInner = function() {
	return (
		global.BASE_URL + "assets/images/summary/rectangles/lab-inner-rectangle.svg"
	);
};

const getTrainerElement = function(name) {
	return global.BASE_URL + "assets/images/elements/" + name + ".svg";
};

const getBeastBuilderButton = function(name) {
	return (
		global.BASE_URL + "assets/images/beastbuilder/buttons/" + name + ".svg"
	);
};

const getBeastBuilderIcon = function(name, sub, isLocked) {
	return (
		global.BASE_URL +
		"assets/images/beastbuilder/icons/" +
		name +
		(sub ? "/" + sub : "") +
		(isLocked ? "-gray" : "") +
		".svg"
	);
};

const getBeastBuilderPart = function(partID) {
	return global.BASE_URL + "public/beastparts/" + partID + ".svg";
};

// For Office

const getMainViewImage = function(name) {
	return global.BASE_URL + "assets/images/office/home/" + name + ".svg";
};

const getOfficeAvatar = function(number = 1) {
	if (number > 13) {
		number = ((number - 1) % 13) + 1;
	}
	return (
		global.BASE_URL +
		"assets/images/office/characters/avatar-" +
		number +
		".svg"
	);
};

const getOfficeIcon = function(iconName) {
	return global.BASE_URL + "assets/images/office/elements/" + iconName + ".svg";
};

const getOfficeCharacter = function(name) {
	return global.BASE_URL + "assets/images/office/characters/" + name + ".svg";
};

const getOfficeElement = function(name, extension = "svg") {
	return (
		global.BASE_URL + "assets/images/office/elements/" + name + "." + extension
	);
};

const getLogoBase = function(name) {
	return global.BASE_URL + "assets/images/logos/" + name;
};

const getLogo = function(name, options = {}) {
	const {extension = "svg"} = options;
	return getLogoBase(name) + `.${extension}`;
};

const getGotProblems = function() {
	return global.BASE_URL + "assets/images/logos/weve-got-problems.svg";
};

const getBookSet = function(grade) {
	return global.BASE_URL + "assets/books/covers/bundle-" + grade + ".png";
};

const getOfficeArrow = function(color = "red") {
	return (
		global.BASE_URL +
		"assets/images/office/elements/arrow-right-" +
		color +
		".svg"
	);
};

const getOfficeCheckmark = function(color) {
	return (
		global.BASE_URL +
		"assets/images/office/elements/checkmark-" +
		color +
		".svg"
	);
};

const getOfficePeople = function(name) {
	return global.BASE_URL + "assets/images/office/people/" + name + ".png";
};

const getOfficeSchoolsPeople = function(name) {
	return (
		global.BASE_URL + "assets/images/office/people/schools/" + name + ".jpg"
	);
};

const getClassTagImage = function(name) {
	return global.BASE_URL + "assets/images/classtag/" + name + ".png";
};

const getParentTutorialImage = function(name) {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/parent-tutorials/" +
		name +
		".svg"
	);
};

const getPlacementTestInviteModalImage = function() {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/placement-test-invite/placement-test-invite-hero.png"
	);
};

// for Checkout

const getCheckoutImage = function(name, extension = "svg") {
	return (
		global.BASE_URL + "assets/images/office/checkout/" + name + "." + extension
	);
};

// Shared

const getScreenshot = function(type) {
	return (
		global.BASE_URL +
		"assets/images/office/elements/screenshots/" +
		type +
		".png"
	);
};

const getPuzzlePiece = function(color = "white") {
	return global.BASE_URL + "assets/images/icons/puzzle-piece-" + color + ".svg";
};

// Umbrella pages

const getUmbrellaPic = function(name) {
	return global.BASE_URL + "assets/images/umbrella/" + name + ".png";
};

const getUmbrellaIcon = function(name) {
	return global.BASE_URL + "assets/images/umbrella/" + name + ".svg";
};

const getBrandIcon = function(name) {
	return global.BASE_URL + "assets/images/umbrella/brands/" + name + ".svg";
};

const getJazz = function(num) {
	return (
		global.BASE_URL + "assets/images/umbrella/jazz/mathjazz-" + num + ".svg"
	);
};

const getDemo = function(imageName) {
	return global.BASE_URL + "assets/images/elements/demo/" + imageName + ".svg";
};

const getVideo = function(videoID, videoHash) {
	const videoString = `video-${videoID}-${videoHash}`;
	return `https://d2deajec2731eq.cloudfront.net/${videoString}/${videoString}.m3u8`;
};

const getGeneralVideo = function(videoName) {
	return `https://d2deajec2731eq.cloudfront.net/${videoName}/${videoName}.m3u8`;
};

const getVideoThumbnail = function(videoID, videoHash) {
	return `https://d1s7nmi5wtowkp.cloudfront.net/video-${videoID}-${videoHash}/1080p-00001.png`;
};

const getVideoCaptions = function(videoID) {
	return global.BASE_URL + "assets/captions/video-" + videoID + ".vtt";
};

const getTheaterIcon = function(name) {
	return global.BASE_URL + "assets/images/icons/theater-" + name + ".svg";
};

const getTheaterJazz = function(name) {
	return global.BASE_URL + "assets/images/themes/theater/jazz/" + name + ".svg";
};

const getTheaterModalBackground = function(name, hasBorder) {
	return (
		global.BASE_URL +
		"assets/images/elements/modals/theater/" +
		name +
		(hasBorder ? "-border" : "") +
		".svg"
	);
};

const getHomescreenImage = function(name, isSimplified = false) {
	const now = moment();

	// the date indicates the start of that season
	// two "windows" for winter: 1/1 -> 2/29, 12/1 -> 12/31
	// default placeholder year 2000 to get strings in ISO format
	const seasons = [
		{season: "winter", start: "2000-01-01"},
		{season: "spring", start: "2000-03-01"},
		{season: "summer", start: "2000-06-01"},
		{season: "fall", start: "2000-09-01"},
		{season: "winter", start: "2000-12-01"},
	];
	const season = _.findLast(seasons, s => {
		const seasonDate = moment(s.start);
		// make sure the years match for comparison
		seasonDate.set({year: now.get("year")});
		return seasonDate <= now;
	}).season;
	const basePath = "assets/images/home/homescreen/";

	// default to this
	let seasonPath = "summer/";
	// Lock the season to summer if we are in our simplified experiment... we'll be getting rid of it sometime in the near future..
	if (season && !isSimplified) {
		seasonPath = `${season}/`;
	}
	const finalPath = "";
	const filename = name + (isSimplified ? "-simplified" : "");
	return (
		global.BASE_URL + basePath + seasonPath + finalPath + filename + ".svg"
	);
};

const getAboutHistory = function(name) {
	return global.BASE_URL + "assets/images/office/history/" + name + ".png";
};

const getChapterPathImage = function(location, part, grade, demo = false) {
	let gradeStr = null;
	if (demo) gradeStr = "demo";
	else if (grade) gradeStr = `grade${grade}`;

	const filepathParts = ["bapath", gradeStr, location, part].filter(Boolean);

	return (
		global.BASE_URL +
		`assets/images/elements/chapter-path/${location}/${filepathParts.join(
			"_"
		)}.svg`
	);
};

const getElevatorImage = function(name) {
	return (
		global.BASE_URL + "assets/images/problem-art/elevator/" + name + ".svg"
	);
};

const getBotImage = function(name) {
	return global.BASE_URL + "assets/images/problem-art/robots/" + name + ".svg";
};

const getBotIcon = function(name, variant) {
	return getBotImage("icon/" + name + "-" + variant);
};

const getBotSprite = function(name) {
	return getBotImage("sprite/" + name);
};

const getBotButton = function(name) {
	return getBotImage("button/button-" + name);
};

const getFlyCatcherImage = function(name) {
	return (
		global.BASE_URL + "assets/images/problem-art/flycatcher/" + name + ".svg"
	);
};

const getBotAnimationFrame = function(botType, name) {
	return (
		global.BASE_URL +
		"assets/images/animations/robots/" +
		botType +
		"/" +
		name +
		".svg"
	);
};

const getPlayingCardImage = function(name) {
	return global.BASE_URL + "assets/images/playingcards/" + name + ".svg";
};

const getPlayingCardCharacterImage = function(name) {
	return getPlayingCardImage("characters/" + name);
};

const getPlayingCardProblemImage = function(name) {
	return getPlayingCardImage("problems/" + name);
};

const getPlayingCardSolutionImage = function(name) {
	return getPlayingCardImage("solutions/" + name);
};

const getPlayingCardArtImage = function(suit, rank) {
	if (["A", "2", "3", "4", "5", "6", "7", "8", "9", "10"].includes(rank)) {
		return getPlayingCardCharacterImage(`a-10-${suit}`);
	} else if (rank === "J") {
		return getPlayingCardCharacterImage(`j-${suit}`);
	} else if (rank === "Q") {
		return getPlayingCardCharacterImage(`q-${suit}`);
	} else if (rank === "K") {
		return getPlayingCardCharacterImage(`k-${suit}`);
	}
};

/**
 * Return the card art class from the card name, i.e. "aTo10", "J", "Q", "K".
 *
 * @param {string} card
 * @returns {string} type
 */
const getTypeFromCard = function(card) {
	let type = "aTo10";
	if (card === "J") {
		type = "J";
	} else if (card === "Q") {
		type = "Q";
	} else if (card === "K") {
		type = "K";
	}
	return type;
};

const getCdnBase = () =>
	`https://${global.ESSENTIAL_RESOURCES_DISTRIBUTION_DOMAIN_NAME}`;

const getRiveAnimationFileFromS3 = fileName =>
	getCdnBase() + "/onboarding/animations/" + fileName + ".riv";

const getLocalRiveAnimationFile = function(fileName) {
	return global.BASE_URL + "assets/animations/rive/" + fileName + ".riv";
};

module.exports = {
	getBeastAvatar,
	getBeastPopin,
	getBeastModalImage,
	getHeadmasterWithMood,
	getBeastInstruction,
	getBeastPartBase,
	getTutorialBookPage,
	getBlockImage,
	getBTenBlockImage,
	getCoinImage,
	getSilhouette,
	getSummaryBeast,
	getSummaryLabBeast,
	getTestOverviewBeast,
	getLoginCharacters,
	getTrainerIconButton,
	getStarImage,
	getLabTypeImage,
	getLabSampleImage,
	getLabTypeCelestialImage,
	getCelestialImage,
	getProfileIcon,
	getGeneralIcon,
	getPirateImage,
	getIntervenedImage,
	getImageForGrade,
	getImageForChapterInGrade,
	getTrayImageByGrade,
	getTrayImageForTeacher,
	getLockImage,
	getStarEarned,
	getTrainerIcon,
	getButton,
	getButtonForSpace,
	getButtonCircle,
	getButtonChapterCircle,
	getOfficeAvatar,
	getProfileDefaultAvatar,
	getBlockBeast,
	getBlockLock,
	getUnderConstruction,
	getAuxButton,
	getHWIcon,
	getChapterCover,
	getBookCover,
	getBookIcon,
	getTooltip,
	getInstructionsModal,
	getConfirmModal,
	getStartTestIllustration,
	getHomeworkAllCompleteIllustration,
	getChapterCompleteIllustration,
	getAcademyGraduateCurtains,
	getAcademyGraduateSpotlight,
	getAcademyGraduateCap,
	getAcademyGraduateCompletionCertificateSvg,
	getChapterPathFinalAcademyTestImage,
	getContinuousPlayStreakIllustration,
	getTopBar,
	getModal,
	getLevelModal,
	getTrainerElement,
	getBeastBuilderButton,
	getBeastBuilderIcon,
	getBeastBuilderPart,
	getOfficeIcon,
	getOfficeCharacter,
	getOfficeElement,
	getLogo,
	getGotProblems,
	getBookSet,
	getOfficeArrow,
	getOfficeCheckmark,
	getOfficePeople,
	getOfficeSchoolsPeople,
	getSparkle,
	getLabElement,
	getSummaryRect,
	getParentTutorialImage,
	getPlacementTestInviteModalImage,
	getCheckoutImage,
	getScreenshot,
	getMainViewImage,
	getPuzzlePiece,
	getUmbrellaPic,
	getUmbrellaIcon,
	getBrandIcon,
	getClassTagImage,
	getJazz,
	getDemo,
	getVideo,
	getGeneralVideo,
	getVideoThumbnail,
	getTheaterIcon,
	getVideoCaptions,
	getTheaterJazz,
	getTheaterModalBackground,
	getVolumeIcon,
	getDefaultAvatarIcon,
	getHomescreenImage,
	getAboutHistory,
	getSummaryLabRectBackground,
	getSummaryLabRectInner,
	getChapterPathImage,
	getElevatorImage,
	getBotImage,
	getBotIcon,
	getBotSprite,
	getBotButton,
	getFlyCatcherImage,
	getBotAnimationFrame,
	getPlayingCardCharacterImage,
	getPlayingCardProblemImage,
	getPlayingCardSolutionImage,
	getPlayingCardArtImage,
	getTypeFromCard,
	getRiveAnimationFileFromS3,
	getLocalRiveAnimationFile,
};
